/* ============================================================
   Aposanitas-Konditionen im Warenkorb (Stand 06.10.2026,
   Entscheidungen Sales). MUSS nach theme.js geladen werden:
   legt sich um gcEnforceMengenrabatt(), genau wie
   gc-adapter-freebie.js um gcEnforcePosFreebie().

   Wann ist ein Warenkorb "Aposanitas"?
   NUR wenn das Warenkorb-Attribut aposanitas_flow = true ist. Das
   setzt ausschliesslich ein DIREKTER Aufruf von
   /pages/aposanitas bzw. /aposanitas (nicht aus dem Shop heraus).
   Von Hand eingegebene Aposanitas-Codes werden
   ausserhalb dieses Modus wieder entfernt.

   Dann gilt (06.10.2026: Testbox-Staffel auch fuer Nachbestellungen):
   - Aposanitas20 (20 % aufs Geraet) nur MIT Igloo Reader Pro DC.
   - Ab 5 Testboxen IMMER Aposanitas15 (bis 31.10.) bzw.
     Aposanitas10 (ab 01.11.) - mit Geraet (Neukund:innen) UND ohne
     Geraet (Nachbestellung). Die Codes sind in Shopify mehrfach pro
     Kunde nutzbar.
   - Die normale Staffel (NACHBESTELLUNG5/10, STARTERKIT2026) gilt im
     Aposanitas-Modus nie - sie wird immer entfernt.
   - Attribut "Partner: Aposanitas" steht an der Bestellung.
   - Ist collabsCode gesetzt, laeuft der 0-%-Collabs-Code mit,
     damit Collabs die Bestellung Aposanitas zuordnet.

   Die Gueltigkeitsdaten stehen zusaetzlich in den Shopify-Rabatten
   selbst. Aendert sich etwas, BEIDES anpassen - und die Anzeige in
   sections/nachbestellung-configurator.liquid (gcr_apo_*) sowie
   snippets/gc-aposanitas-cart.liquid.
   ============================================================ */
window.gcAposanitas = Object.assign({
  dcVariantId: 59065942540613,        /* Igloo | Reader Pro DC */
  minBoxes: 5,
  deviceRate: 20,
  speedRate: 15,
  baseRate: 10,
  speedEnd: '2026-11-01T00:00:00+01:00',
  deviceCode: 'Aposanitas20',
  speedCode: 'Aposanitas15',
  baseCode: 'Aposanitas10',
  collabsCode: ''                     /* 0-%-Code aus Shopify Collabs, sobald angelegt */
}, window.gcAposanitas || {});

function gcAposanitasSpeedActive(){
  return new Date() < new Date(window.gcAposanitas.speedEnd);
}
function gcAposanitasBoxRate(){
  return gcAposanitasSpeedActive() ? window.gcAposanitas.speedRate : window.gcAposanitas.baseRate;
}

async function gcEnforceAposanitas(){
  try{
    const C = window.gcAposanitas;
    const res = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await res.json();
    const attrs = cart.attributes || {};
    const current = (cart.discount_codes || []).map(d => d.code);

    const own = [C.deviceCode, C.speedCode, C.baseCode, C.collabsCode]
      .filter(Boolean).map(c => c.toUpperCase());
    const isOwn = c => own.indexOf(c.toUpperCase()) !== -1;
    const staffel = ['NACHBESTELLUNG5', 'NACHBESTELLUNG10', 'STARTERKIT2026'];

    /* Aposanitas-Modus gibt es NUR ueber den direkten Aufruf der Seite
       (setzt das Attribut, siehe sections/aposanitas-configurator.liquid).
       Ausserhalb davon werden Aposanitas-Codes aus dem Warenkorb entfernt. */
    const isApo = attrs.aposanitas_flow === 'true';
    if(!isApo){
      if(current.some(isOwn)){
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ discount: current.filter(c => !isOwn(c)).join(',') })
        });
        if(typeof gcRefreshCartSection === 'function') await gcRefreshCartSection();
      }
      return;
    }

    let dcQty = 0, boxQty = 0;
    cart.items.forEach(i => {
      if(i.variant_id === C.dcVariantId) dcQty += i.quantity;
      if(i.product_type === 'Testkit') boxQty += i.quantity;
    });

    const target = [];
    if(dcQty >= 1) target.push(C.deviceCode);
    if(boxQty >= C.minBoxes) target.push(gcAposanitasSpeedActive() ? C.speedCode : C.baseCode);
    if(C.collabsCode) target.push(C.collabsCode);

    /* Im Aposanitas-Modus gilt die normale Staffel nie (auch nicht bei
       Nachbestellungen) - die Aposanitas-Staffel ersetzt sie. */
    const rest = current.filter(c => !isOwn(c) && staffel.indexOf(c.toUpperCase()) === -1);
    const desired = target.concat(rest);

    const body = {};
    const same = desired.length === current.length && desired.every(c => current.indexOf(c) !== -1);
    if(!same) body.discount = desired.join(',');
    if(attrs.Partner !== 'Aposanitas'){
      body.attributes = { aposanitas_flow: 'true', Partner: 'Aposanitas' };
    }
    /* Achtung: discount kann ein leerer String sein (alle Codes entfernen) -
       deshalb auf das Vorhandensein pruefen, nicht auf den Wert. */
    const changeCodes = Object.prototype.hasOwnProperty.call(body, 'discount');
    if(!changeCodes && !body.attributes) return;

    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify(body)
    });
    if(changeCodes && typeof gcRefreshCartSection === 'function') await gcRefreshCartSection();
  } catch(err){
    console.error('Aposanitas-Check fehlgeschlagen:', err);
  }
}

(function(){
  const orig = window.gcEnforceMengenrabatt;
  window.gcEnforceMengenrabatt = async function(){
    if(typeof orig === 'function') await orig.apply(this, arguments);
    await gcEnforceAposanitas();
  };
})();
